import { PreviewCoursePage } from '@hendrx/core/courses';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/studio/courses/preview/$courseDraftId/')({
  component: PreviewCoursePage
});
